<template>
  <div style="width: 100%; padding: 10px">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <h1 style="font-size: 24px; margin: 0;">{{ $t("fitness.header") }} - {{ $t("timeline.daily_view") }}</h1>
      <v-btn
        text
        :loading="l_import"
        :disabled="l_import"
        color="default"
        @click="openRangeImport"
      >
        <i class="fad fa-file-import" style="margin-right: 5px"></i>
        <span class="hidden-xs-only">{{ $t("fitness.import_date_range_title") }}</span>
      </v-btn>
    </div>
    <p style="margin-top: 5px; text-align: center">
      <v-btn @click="dayBack" text>
        <i class="fal fa-chevron-left"></i>
      </v-btn>
      <v-btn text @click="d_date_select = true">
        <i
          style="margin-left: 5px; cursor: pointer"
          class="fad fa-calendar-day"
        ></i>
      </v-btn>
      <v-btn @click="dayForward" :disabled="todayDate === cardDate" text>
        <i class="fal fa-chevron-right"></i>
      </v-btn>
      <br>
      <span style="font-size:23px;">{{ formattedDate }}</span>
    </p>
    <v-layout
      row
      wrap
      style="margin-left: 0; margin-right: 0; margin-top: 20px"
    >
      <info-tile
        :name="$t('fitness.steps')"
        :data="current_fitness_data && current_fitness_data.steps ? current_fitness_data.steps : null"
        :loading="l_data"
        icon="shoe-prints"
      ></info-tile>
      <info-tile
        :name="$t('fitness.calories')"
        :data="current_fitness_data && current_fitness_data.calories ? current_fitness_data.calories : null"
        :loading="l_data"
        icon="flame"
      ></info-tile>
      <info-tile
        :name="$t('fitness.floors')"
        :data="current_fitness_data && current_fitness_data.floors > 0 ? Math.floor(current_fitness_data.floors) : null"
        :loading="l_data"
        icon="level-up"
      ></info-tile>
      <info-tile
        :name="$t('fitness.distance')"
        :data="
          current_fitness_data && current_fitness_data.distance ? current_fitness_data.distance + ' km' : null
        "
        :loading="l_data"
        icon="map"
      ></info-tile>
      <info-tile
        :name="$t('fitness.resting_heart_rate')"
        :data="
          current_fitness_data && current_fitness_data.heart_rate && current_fitness_data.heart_rate > 0
            ? current_fitness_data.heart_rate + ' bpm'
            : null
        "
        :loading="l_data"
        icon="heart"
      ></info-tile>
      <info-tile
        :name="$t('fitness.sleep_effective')"
        :data="
          current_fitness_data && current_fitness_data.sleep_duration && current_fitness_data.sleep_duration > 0
            ? getHoursAndMinutesFromMinutes(current_fitness_data.sleep_duration)
            : null
        "
        :loading="l_data"
        icon="moon"
      ></info-tile>
      <info-tile
        :name="$t('fitness.sleep_total')"
        :data="
          current_fitness_data && current_fitness_data.sleep_total && current_fitness_data.sleep_total > 0
            ? getHoursAndMinutesFromMinutes(current_fitness_data.sleep_total)
            : null
        "
        :loading="l_data"
        icon="moon"
      ></info-tile>
      <info-tile
        :name="$t('fitness.weight')"
        :data="current_fitness_data && current_fitness_data.weight && current_fitness_data.weight > 0 ? current_fitness_data.weight + ' kg' : null"
        :loading="l_data"
        icon="weight"
      ></info-tile>
      <info-tile
        :name="$t('fitness.body_fat')"
        :data="current_fitness_data && current_fitness_data.body_fat && current_fitness_data.body_fat > 0 ? current_fitness_data.body_fat + ' %' : null"
        :loading="l_data"
        icon="percentage"
      ></info-tile>
      <info-tile
        :name="$t('fitness.muscle_mass')"
        :data="current_fitness_data && current_fitness_data.muscle_mass && current_fitness_data.muscle_mass > 0 ? current_fitness_data.muscle_mass + ' kg' : null"
        :loading="l_data"
        icon="dumbbell"
      ></info-tile>
      <info-tile
        :name="$t('fitness.bone_mass')"
        :data="current_fitness_data && current_fitness_data.bone_mass && current_fitness_data.bone_mass > 0 ? current_fitness_data.bone_mass + ' kg' : null"
        :loading="l_data"
        icon="bone"
      ></info-tile>
      <info-tile
        :name="$t('fitness.hydration')"
        :data="current_fitness_data && current_fitness_data.hydration && current_fitness_data.hydration > 0 ? current_fitness_data.hydration + ' kg' : null"
        :loading="l_data"
        icon="tint"
      ></info-tile>
      <info-tile
        :name="$t('fitness.spo2')"
        :data="current_fitness_data && current_fitness_data.spo2 && current_fitness_data.spo2 > 0 ? current_fitness_data.spo2 + ' %' : null"
        :loading="l_data"
        icon="lungs"
      ></info-tile>
      <info-tile
        :name="$t('fitness.body_temperature')"
        :data="current_fitness_data && current_fitness_data.body_temperature && current_fitness_data.body_temperature > 0 ? current_fitness_data.body_temperature + ' °C' : null"
        :loading="l_data"
        icon="thermometer-half"
      ></info-tile>
    </v-layout>
    <v-layout
      row
      wrap
      style="margin: 5px"
      :style="{ marginTop: current_fitness_data ? '20px' : '5px' }"
    >
      <v-flex xs12 sm12 style="padding-top: 10px; text-align: center">
        <p style="margin-right: 10px" v-if="current_fitness_data === undefined && !l_data">
          {{ $t("fitness.no_data_here") }}
        </p>
      </v-flex>
      <v-flex xs12 sm12 v-if="current_fitness_data">
        <p
          style="width: 100%; text-align: right; margin-top: 10px"
          v-if="current_fitness_data"
        >
          {{
            $t("source") +
            ": " +
            current_fitness_data.imported_from[0].toUpperCase() +
            current_fitness_data.imported_from.slice(1)
          }}
        </p>
      </v-flex>
    </v-layout>

    <v-dialog v-model="d_date_select" max-width="400">
      <v-card>
        <v-card-title class="headline">{{
          $t("today.select_date")
        }}</v-card-title>
        <v-card-text style="text-align: center">
          <v-date-picker
            :allowed-dates="allowedDates"
            :first-day-of-week="1"
            :value="cardDate"
            @change="selectDate"
          ></v-date-picker>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="d_range_import" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">{{ $t("fitness.import_date_range_title") }}</v-card-title>
        <v-card-text style="text-align: center" v-if="!rangeProgress.active">
          <v-date-picker
            v-model="range_dates"
            range
            :first-day-of-week="1"
            :allowed-dates="allowedDates"
            :picker-date.sync="rangePickerDate"
            style="width: 100%; margin-top: 10px;"
          ></v-date-picker>
        </v-card-text>
        <v-card-text v-else style="padding-top: 20px; padding-bottom: 30px;">
          <div class="mb-2 text-center" style="font-size: 16px; font-weight: bold;">
             {{ rangeProgress.current }} / {{ rangeProgress.total }}
          </div>
          <v-progress-linear
            :value="(rangeProgress.current / rangeProgress.total) * 100"
            height="20"
            color="primary"
          ></v-progress-linear>
          <p class="mt-4 text-center" style="font-size: 14px; color: grey; margin-bottom: 0;">
             {{ $t('fitness.importing_progress', { current: rangeProgress.current, total: rangeProgress.total, date: rangeProgress.date }) }}
          </p>
        </v-card-text>
        <v-card-actions v-if="!rangeProgress.active">
          <v-spacer></v-spacer>
          <v-btn text @click="d_range_import = false">{{ $t("general.cancel") }}</v-btn>
          <v-btn color="primary" @click="startImportRange" :disabled="range_dates.length === 0">{{ $t("fitness.import") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { storage } from "../schmucklicloud";
import { Notifications } from "../notification";
import InfoTile from "../components/fitness/InfoTile.vue";
var numeral = require("numeral");

var start_date = new Date();
start_date.setDate(start_date.getDate() - 1);

export default {
  data() {
    return {
      current_date: start_date,
      current_fitness_data: undefined,
      current_fitness_data_row_id: undefined, // The row id from the schmuckliCloud service

      //Dialogs
      d_date_select: false,
      d_range_import: false,

      range_dates: [],
      rangePickerDate: null,
      rangeProgress: { active: false, current: 0, total: 0, date: '' },

      l_data: true,
      l_today: false,
      l_import: false, // Is the import session active?

      add_title: "",
      add_text: "",

      withings_auth_attempt: 0,

      today: null,
      mood: 0,
    };
  },
  components: {
    InfoTile,
  },
  watch: {
    cardDate() {
      this.updateUrl();
      this.loadData(this.cardDate);
    },
  },
  mounted() {
    var query_date = this.$route.params.date;
    if (query_date !== undefined) {
      this.current_date = new Date(query_date);
    } else {
      this.updateUrl();
    }
    this.loadData(this.cardDate);
  },
  computed: {
    cardDate() {
      return (
        this.current_date.getFullYear() +
        "-" +
        (this.current_date.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (this.current_date.getDate() + "").padStart(2, "0")
      );
    },
    formattedDate() {
      var months = [
        this.$t("general.month.january"),
        this.$t("general.month.february"),
        this.$t("general.month.march"),
        this.$t("general.month.april"),
        this.$t("general.month.may"),
        this.$t("general.month.june"),
        this.$t("general.month.july"),
        this.$t("general.month.august"),
        this.$t("general.month.september"),
        this.$t("general.month.october"),
        this.$t("general.month.november"),
        this.$t("general.month.december"),
      ];

      var day_of_week = [
        this.$t("general.day_of_week.sunday"),
        this.$t("general.day_of_week.monday"),
        this.$t("general.day_of_week.tuesday"),
        this.$t("general.day_of_week.wednesday"),
        this.$t("general.day_of_week.thursday"),
        this.$t("general.day_of_week.friday"),
        this.$t("general.day_of_week.saturday"),
      ];

      return (
        day_of_week[this.current_date.getDay()] +
        ", " +
        this.current_date.getDate() +
        ". " +
        months[this.current_date.getMonth()] +
        " " +
        this.current_date.getFullYear()
      );
    },
    todayDate() {
      var today = new Date();
      return (
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1 + "").padStart(2, "0") +
        "-" +
        (today.getDate() + "").padStart(2, "0")
      );
    },
  },
  methods: {
    openRangeImport() {
      this.rangePickerDate = this.cardDate.substring(0, 7);
      this.range_dates = [this.cardDate, this.cardDate];
      this.d_range_import = true;
    },
    dayBack() {
      this.current_date.setDate(this.current_date.getDate() - 1);
      this.current_date = new Date(this.current_date);
    },
    dayForward() {
      this.current_date.setDate(this.current_date.getDate() + 1);
      this.current_date = new Date(this.current_date);
    },

    selectDate(date) {
      this.current_date = new Date(date);
      this.d_date_select = false;
    },
    updateUrl() {
      if (this.$route.params.date !== this.cardDate) {
        this.$router.replace('/fitness/' + this.cardDate).catch(() => {});
      }
    },

    // Load the data from the sC Service
    async loadData(date) {
      this.l_data = true;
      var response = await storage.get("fitness_daily", [
        {
          column: "date",
          operator: "==",
          value: date,
        },
      ]);

      if (response.isOK) {
        if (response.data) {
          this.current_fitness_data_row_id = response.data[0].id;
          this.current_fitness_data = response.data[0].data;

          // Formatting the data
          if (this.current_fitness_data.steps == 0) this.current_fitness_data.steps = null;
          else {
              this.current_fitness_data.steps = numeral(this.current_fitness_data.steps).format("0,000").replace(/,/g, "'");
          }

          if (this.current_fitness_data.calories == 0) this.current_fitness_data.calories = null;
          else {
              this.current_fitness_data.calories = numeral(this.current_fitness_data.calories).format("0,000").replace(/,/g, "'");
          }

          if (this.current_fitness_data.distance == 0) this.current_fitness_data.distance = null;
          else {
              this.current_fitness_data.distance = numeral(this.current_fitness_data.distance).format("0.00").replace(/,/g, "'");
          }
        } else {
          this.current_fitness_data_row_id = undefined;
          this.current_fitness_data = undefined;
        }
      } else {
        this.current_fitness_data_row_id = undefined;
        this.current_fitness_data = undefined;
      }
      this.l_data = false;
    },

    async startImportWithings(targetDate, silent = false, isRetry = false) {
      if (typeof targetDate !== "string") targetDate = this.cardDate;
      this.l_import = true;
      var token_object = localStorage.getItem("withings_auth") || undefined;
      if (token_object === undefined) {
        try {
          await this.authenticateWithings();
          return await this.startImportWithings(targetDate, silent, true);
        } catch (e) {
          this.l_import = false;
          throw new Error("Authentication required");
        }
      } else {
        var access_token = JSON.parse(token_object).body.access_token;

        try {
          // Clean data / Remove the data, which is already there for the active date
          var existing = await storage.get("fitness_daily", [
            { column: "date", operator: "==", value: targetDate },
          ]);
          if (existing.isOK && existing.data && existing.data.length > 0) {
            await storage.delete("fitness_daily", existing.data[0].id);
          }

          // Steps, Elevation, Distance, Calories, HR Average
          var body = new FormData();
          body.append("action", "getactivity");
          body.append(
            "data_fields",
            "steps,elevation,totalcalories,distance,hr_average"
          );
          body.append("category", 2);
          body.append("startdateymd", targetDate);
          body.append("enddateymd", targetDate);

          var response_metrics = await axios({
            url: "https://wbsapi.withings.net/v2/measure",
            method: "post",
            data: body,
            headers: {
              Authorization: "Bearer " + access_token,
              "Content-Type": "multipart/form-data",
            },
          });

          if (response_metrics.data.status !== 0) {
            throw new Error("API returned status " + response_metrics.data.status);
          }

          var data_steps = undefined;
          if (response_metrics.data.body && response_metrics.data.body.activities && response_metrics.data.body.activities.length > 0) {
            data_steps = response_metrics.data.body.activities[0];
          }

          var sC_response_steps = await storage.insert("fitness_daily", {
            date: targetDate,
            steps: data_steps ? data_steps.steps : 0,
            calories: data_steps ? Math.floor(data_steps.totalcalories) : 0,
            distance: data_steps ? data_steps.distance / 1000 : 0,
            floors: data_steps ? data_steps.elevation : 0,
            heart_rate: data_steps && data_steps.hr_average ? data_steps.hr_average : 0,
            imported_from: "withings",
          });

          if (!sC_response_steps.isOK) {
            Notifications.show(
              "There was a problem while importing the basic data."
            );
            throw new Error("Could not insert basic data");
          }

          var rowset_id = sC_response_steps.data.id;

          // Sleep data
          try {
            var sleep_body = new FormData();
            sleep_body.append("action", "getsummary");
            sleep_body.append(
              "data_fields",
              "durationtosleep,durationtowakeup,lightsleepduration,remsleepduration,deepsleepduration,wakeupduration"
            );
            sleep_body.append("startdateymd", targetDate);
            sleep_body.append("enddateymd", targetDate);

            var response_sleep = await axios({
              url: "https://wbsapi.withings.net/v2/sleep",
              method: "post",
              data: sleep_body,
              headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "multipart/form-data",
              },
            });

            var data_sleep = undefined;
            if (response_sleep.data.status === 0 && response_sleep.data.body && response_sleep.data.body.series && response_sleep.data.body.series.length > 0) {
              data_sleep = response_sleep.data.body.series[0].data;
            }

            var sleep_duration = 0,
              sleep_total = 0;

            if (data_sleep) {
              sleep_duration += data_sleep.deepsleepduration || 0;
              if (data_sleep.lightsleepduration) {
                sleep_duration += data_sleep.lightsleepduration;
              }
              if (data_sleep.remsleepduration) {
                sleep_duration += data_sleep.remsleepduration;
              }

              sleep_total += sleep_duration;
              sleep_total += data_sleep.durationtosleep || 0;
              sleep_total += data_sleep.durationtowakeup || 0;
              if (data_sleep.wakeupduration) {
                sleep_total += data_sleep.wakeupduration;
              }
            }

            var sC_response_sleep = await storage.update(
              "fitness_daily",
              rowset_id,
              {
                sleep_duration: sleep_duration / 60, // To minutes
                sleep_total: sleep_total / 60,
              }
            );

            if (!sC_response_sleep.isOK) {
              Notifications.show(
                "There was a problem while importing the sleep data."
              );
            }
          } catch (e) {
            console.warn("Could not pull sleep data:", e);
          }

          // Body composition data
          try {
            var startdate = Math.floor(new Date(targetDate + "T00:00:00").getTime() / 1000);
            var enddate = Math.floor(new Date(targetDate + "T23:59:59").getTime() / 1000);

            var meas_body = new FormData();
            meas_body.append("action", "getmeas");
            meas_body.append("category", 1);
            meas_body.append("startdate", startdate);
            meas_body.append("enddate", enddate);

            var response_meas = await axios({
              url: "https://wbsapi.withings.net/measure",
              method: "post",
              data: meas_body,
              headers: {
                Authorization: "Bearer " + access_token,
                "Content-Type": "multipart/form-data",
              },
            });

            var data_meas = {
              weight: 0,
              body_fat: 0,
              muscle_mass: 0,
              bone_mass: 0,
              hydration: 0,
              spo2: 0,
              body_temperature: 0
            };

            if (response_meas.data.status === 0 && response_meas.data.body && response_meas.data.body.measuregrps) {
              for (let grp of response_meas.data.body.measuregrps) {
                for (let measure of grp.measures) {
                  let value = measure.value * Math.pow(10, measure.unit);
                  if (measure.type === 1) data_meas.weight = value; // Weight (kg)
                  if (measure.type === 6) data_meas.body_fat = value; // Fat Ratio (%)
                  if (measure.type === 76) data_meas.muscle_mass = value; // Muscle Mass (kg)
                  if (measure.type === 88) data_meas.bone_mass = value; // Bone Mass (kg)
                  if (measure.type === 77) data_meas.hydration = value; // Hydration (kg)
                  if (measure.type === 54) data_meas.spo2 = value; // SpO2 (%)
                  if (measure.type === 71) data_meas.body_temperature = value; // Body Temperature (°C)
                  if (measure.type === 73 && !data_meas.body_temperature) data_meas.body_temperature = value; // Skin Temperature (°C)
                  if (measure.type === 12 && !data_meas.body_temperature) data_meas.body_temperature = value; // Temperature (°C)
                }
              }

              if (data_meas.weight > 0) data_meas.weight = Math.round(data_meas.weight * 100) / 100;
              if (data_meas.body_fat > 0) data_meas.body_fat = Math.round(data_meas.body_fat * 100) / 100;
              if (data_meas.muscle_mass > 0) data_meas.muscle_mass = Math.round(data_meas.muscle_mass * 100) / 100;
              if (data_meas.bone_mass > 0) data_meas.bone_mass = Math.round(data_meas.bone_mass * 100) / 100;
              if (data_meas.hydration > 0) data_meas.hydration = Math.round(data_meas.hydration * 100) / 100;
              if (data_meas.spo2 > 0) data_meas.spo2 = Math.round(data_meas.spo2 * 100) / 100;
              if (data_meas.body_temperature > 0) data_meas.body_temperature = Math.round(data_meas.body_temperature * 100) / 100;

              if (data_meas.weight > 0 || data_meas.body_fat > 0 || data_meas.muscle_mass > 0 || data_meas.bone_mass > 0 || data_meas.hydration > 0 || data_meas.spo2 > 0 || data_meas.body_temperature > 0) {
                var sC_response_meas = await storage.update(
                  "fitness_daily",
                  rowset_id,
                  data_meas
                );

                if (!sC_response_meas.isOK) {
                  Notifications.show(
                    "There was a problem while importing the body composition data."
                  );
                }
              }
            } else if (response_meas.data.status !== 0) {
              console.warn("API returned status " + response_meas.data.status + " for body composition. Re-authentication may be required.");
            }
          } catch (e) {
            console.warn("Could not pull body composition data:", e);
          }

          if (!silent) {
            Notifications.show(
              "The data for " +
                targetDate +
                " has been imported from Withings."
            );
          }
          this.withings_auth_attempt = 0;
          this.l_import = false;
          if (targetDate === this.cardDate) this.loadData(this.cardDate);
          return true;
        } catch (e) {
          console.error(e);
          if (e.message && e.message.includes("status 401")) {
            if (!isRetry) {
              try {
                await this.authenticateWithings();
                return await this.startImportWithings(targetDate, silent, true);
              } catch (authError) {
                this.l_import = false;
                if (!silent) Notifications.show("Withings import failed: " + e.message);
                throw authError;
              }
            }
          }
          
          this.l_import = false;
          if (!silent) Notifications.show("Withings import failed: " + e.message);
          throw e;
        }
      }
    },
    async startImportRange() {
      if (!this.range_dates || this.range_dates.length === 0) return;
      
      let dates = [];
      let d1 = new Date(this.range_dates[0]);
      let d2 = new Date(this.range_dates[this.range_dates.length - 1]);
      
      if (d1 > d2) {
        let temp = d1;
        d1 = d2;
        d2 = temp;
      }
      
      let curr = new Date(d1);
      while(curr <= d2) {
        dates.push(curr.getFullYear() + "-" + (curr.getMonth() + 1 + "").padStart(2, "0") + "-" + (curr.getDate() + "").padStart(2, "0"));
        curr.setDate(curr.getDate() + 1);
      }
      
      let successCount = 0;
      this.rangeProgress = { active: true, current: 0, total: dates.length, date: '' };
      
      for (let i = 0; i < dates.length; i++) {
        let dateToSync = dates[i];
        this.rangeProgress.current = i + 1;
        let dParts = dateToSync.split('-');
        this.rangeProgress.date = new Date(parseInt(dParts[0]), parseInt(dParts[1]) - 1, parseInt(dParts[2])).toLocaleDateString('de-CH');
        
        try {
          await this.startImportWithings(dateToSync, true);
          successCount++;
        } catch (err) {
          console.error("Range import failed on date", dateToSync, err);
          Notifications.show(this.$t("fitness.import_failed", { date: dateToSync }));
          break;
        }
      }
      
      this.rangeProgress.active = false;
      if (successCount > 0) {
        Notifications.show(this.$t("fitness.import_success", { count: successCount }));
      }
      this.d_range_import = false;
      this.loadData(this.cardDate);
    },

    authenticateWithings() {
      return new Promise((resolve, reject) => {
        (async () => {
          if (this.withings_auth_attempt >= 2) {
            Notifications.show("Withings import failed: Could not authorize after multiple attempts.");
            this.l_import = false;
            this.withings_auth_attempt = 0;
            reject(new Error("Could not authorize"));
            return;
          }

          var withings_auth = localStorage.getItem("withings_auth") || undefined;
          if (withings_auth !== undefined && this.withings_auth_attempt === 0) {
            this.withings_auth_attempt++;

            if (!JSON.parse(withings_auth).body.refresh_token) {
              localStorage.removeItem("withings_auth");
              reject(new Error("No refresh token available"));
              return;
            }

            try {
              var response = await axios.get(
                "https://func-chn-tracky.azurewebsites.net/api/TrackyWithingsAuth?code=hpPOraZ9KElAHGcjYIteKopToNiH9-_Jw986IXVg3SCwAzFu1E1P6w==&" +
                  new URLSearchParams({
                    refresh_token: JSON.parse(withings_auth).body.refresh_token,
                    function: "refresh_token",
                  }).toString()
              );

              if (response.status === 200) {
                if (response.data.status !== 0) {
                  localStorage.removeItem("withings_auth");
                  reject(new Error("Token refresh failed"));
                } else {
                  localStorage.setItem(
                    "withings_auth",
                    JSON.stringify(response.data)
                  );
                  resolve();
                }
              } else {
                 localStorage.removeItem("withings_auth");
                 reject(new Error("Token refresh failed with status " + response.status));
              }
            } catch(e) {
              localStorage.removeItem("withings_auth");
              reject(e);
            }
          } else {
            this.withings_auth_attempt++;
            var withings_window = window.open(
              "https://account.withings.com/oauth2_user/authorize2?client_id=87231d61e5ea317f7d0fb6eb1328210042bbf989a2c1084904bb0f9a3406b491&redirect_uri=https://tracky.schmuckli.dev/fitness/import_withings.html&response_type=code&scope=user.activity,user.metrics&state=" +
                new Date().getTime(),
              "withings-sign-in",
              "height=700,width=550"
            );

            if (!withings_window) {
              Notifications.show("Please allow popups to sign in to Withings.");
              this.l_import = false;
              reject(new Error("Popup blocked"));
              return;
            }

            var checkWithingsTimer = setInterval(function () {
              if (withings_window.closed) {
                clearInterval(checkWithingsTimer);
                resolve();
              }
            }.bind(this), 500);
          }
        })();
      });
    },

    // Formatters
    allowedDates(val) {
      var date = new Date(val);
      return new Date() - date > 0;
    },
    getHoursAndMinutesFromMinutes(input_minutes) {
      var minutes = parseInt(input_minutes);
      var hours = Math.floor(minutes / 60);
      minutes = minutes % 60;
      return hours + " hrs " + minutes + " mins";
    },
  },
};
</script>

<style>
.mx-auto {
  margin-bottom: 30px;
}
</style>
